import React from "react";
import { Col, Row } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomCheckBox from "../../../../../../common/custom-checkbox/custom-checkbox";

const DeclarationForm = ({ control }) => {
  return (
    <Row gutter={[32, 20]}>
      <Col span={24}>
        <Controller
          name="declaration"
          control={control}
          rules={{ required: "You must accept the Declaration" }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomCheckBox
              id="declaration"
              label="I confirm the above information is accurate and I am authorized to register this school."
              checked={value}
              onChange={(e) => onChange(e.target.checked)}
              errorMessage={error?.message}
            />
          )}
        />
      </Col>
      <Col span={24}>
        <Controller
          name="digital_signature"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="digital_signature"
              label="Digital Signature"
              showOptional="(Full Name)"
              labelColor="#171717"
              rows={3}
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default DeclarationForm;